import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core'
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'

export interface GbPresenterDialogRenameSlideData {
  name: string
}

@Component({
  selector: 'gb-presenter-dialog-rename-slide',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    GbDashboardSharedUiModule,
  ],
  templateUrl: './gb-presenter-dialog-rename-slide.component.html',
  styleUrl: './gb-presenter-dialog-rename-slide.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterDialogRenameSlideComponent {
  private readonly dialogRef = inject(MatDialogRef<GbPresenterDialogRenameSlideComponent, string | null>)

  nameControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(30)],
  })

  constructor(@Inject(MAT_DIALOG_DATA) data: GbPresenterDialogRenameSlideData) {
    this.nameControl.setValue(data?.name || '')
  }

  cancel(): void {
    this.dialogRef.close(null)
  }

  save(): void {
    const name = this.nameControl.value.trim()
    if (!name) {
      this.nameControl.markAsTouched()
      return
    }

    this.dialogRef.close(name)
  }
}
